<template>
  <div class="customer botPage">
    <mbHeader :title="$t('customer_service')" :left="true" :lang="true"></mbHeader>
    <customerService></customerService>
  </div>
</template>

<script>
import mbHeader from "../../components/mobile/mbHeader";
import customerService from '../Profile/customerService';

export default {
  name: "mobileCustomer",
  components: {mbHeader,customerService},
}
</script>

<style scoped lang="less">
.customer {
  min-height: 100vh;
  padding: 66px 16px 32px;
  background-color: rgba(0, 0, 0, 0.02);
}
</style>



// WEBPACK FOOTER //
// src/view/mobile/mobileCustomer.vue